module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "plates"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "3em",
      "font-size": "1.5em",
      "font-weight": "normal"
    }
  }, [_vm._v("LIST OF PLATES")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S-class submarine leaving harbour")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The sea rolling along the bulging curve of our saddle-tanks”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Control-room of a T-class submarine, from a painting by Barnett Freedman")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain at the periscope")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hydroplane operators")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("U-class submarine")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the conning-tower")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Motor-room and engine-room")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Target sinking, taken through the periscope")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destroyer hunting a submarine, taken through the periscope")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("("), _c('em', [_vm._v("a")]), _vm._v(") Ben Bryant ("), _c('em', [_vm._v("b")]), _vm._v(") George Colvin")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Torpedo-stowage compartment, or “Fore Ends”")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate13_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13, 14, 15   Diving and surfacing")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Underwater photograph of "), _c('em', [_vm._v("Auriga")]), _vm._v("’s bridge")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Underwater photograph of torpedo being fired")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fuelling alongside the depot ship")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Saracen")]), _vm._v(" in Malta")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“The maze of pipes”")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The galley")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Storm")]), _vm._v(" on her first run in the River Mersey")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  })]), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Down the hatch")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H.M.S. "), _c('em', [_vm._v("Forth")]), _vm._v(", submarine depot ship")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unloading kit after a patrol")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loading a torpedo into its tube")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Returning from the North Cape patrol, November 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "parahangblk1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate28_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28, 29, 30, 31   "), _c('em', [_vm._v("Storm")]), _vm._v("’s officers")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate32",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Storm")]), _vm._v(" nearing Trincomalee after a patrol")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate33",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Storm")]), _vm._v("’s bridge")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Picking our Japanese prisoner out of the sea")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Oerlikon")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three stalwarts: Taylor, Evans and Greenway")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dicky Fisher and boarding party in action")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate38",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Storm")]), _vm._v(" entering Haslar Creek on return from Far East")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "0.0em",
      "padding-left": "3.0em",
      "text-indent": "-1.0em"
    }
  }, [_c('span', {
    staticClass: "label",
    staticStyle: {
      "text-indent": "-3.0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home again!")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "margin-top": "1.0em",
      "font-size": ".9em"
    }
  }, [_vm._v("COPYRIGHT ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The painting by Barnett Freedman ("), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 3")]), _vm._v(") is Crown Copyright and is reproduced by courtesy of the Trustees of the Tate Gallery.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plates 4")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate13_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" are also Crown Copyright.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plates 7")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate13_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" are the Copyright of "), _c('em', [_vm._v("Picture Pest")]), _vm._v(" Library.")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plates 2")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate13_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/text/22_chapter_11#plate26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" are the Copyright of Central Press Photos.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06bf5e63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/08a_plates.vue
// module id = 78
// module chunks = 0